<template>
  <div class="text-center confirmed">
    <el-row>
      <el-col :span="12" :offset="6"><h1>{{ $t('reservationConfirm.thanks')}} <span>{{ $t('reservationConfirm.thanks_1')}}</span> {{ $t('reservation.symbol')}}</h1></el-col>
      <el-col  :md="24" class="sub_title"><h1>{{ $t('reservationConfirm.confirmed')}} <span>{{ $t('reservationConfirm.confirmed_1')}}</span> {{ $t('reservationConfirm.confirmed_2')}}</h1></el-col>
    </el-row>
    <el-row>
      <el-col :span="12" :offset="6"><i class="success_img"></i></el-col>
    </el-row>
    <el-row class="text-center">
      <p>{{ $t('reservationConfirm.contact')}}</p>
    </el-row>
    <el-row>
      <el-col :span="12" :offset="6"><el-button @click="backToHome">{{ $t('reservationConfirm.backHome')}}</el-button></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ReservationConfirm",
  data() {
    return {
      successUrl: this.$attrs.successUrl
    };
  },
  methods: {
    backToHome() {
      window.location.href = this.successUrl;
    }
  }

};
</script>

<style scoped>
.confirmed{
    padding: 135px 0;
}
h1 {
    font-family: GothamBold;
    font-size: 36px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.9px;
    text-align: center;
    color: #0d253f;
    margin: 0;
}

h1 span {
    width: 100px;
    height: 95px;
    color: #3b6bbf;
}

.sub_title{
  text-align: center;
}

i.success_img{
  display: block;
  margin: 35px auto;
  background: url('../../../website_20/static/img/stacked-group-5.svg') no-repeat;
  background-position: -135px 0;
  width: 100px;
  height: 95px;
}
p {
    width: 533px;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.4px;
    margin: 0 auto 35px;
    color: #666;
}
.el-button{
    width: 160px;
    height: 40px;
    color: #fff;
    background-color: #3b6bbf;
    font-family: GothamBold;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.4px;
    margin: 0 auto;
}
.text-center{
  text-align: center;
}

@media (max-width: 768px) {
  /* p{

  } */
}

@media (max-width: 414px) {
  p{
    width: 326px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ReservationConfirm.vue